module.exports = {
    apiUrl: 'https://ifa-api-homolog-vidu.onrender.com/api'
}
